import {Component} from "@angular/core";
import {Control, Validators, Validator, AbstractControl} from "@angular/common";

class ColorCodeValidator implements Validator {
  private static pattern = /^#[0-9A-F]{6}$/i;

  validate(c: AbstractControl): { [key: string]: any } {
    if (!c.value) {
      return null;
    }
    if (typeof c.value === "string") {
      return ColorCodeValidator.pattern.test(c.value) ? null : { colorCode: true };
    }
    return null;
  }
}

class AsyncValidator {
  static validate(c: AbstractControl): Promise<{ [key: string]: any }> {
    return new Promise(resolve => {
      setTimeout(() => {
        if (!c.value) {
          resolve(null);
          return;
        }
        if (typeof c.value === "string") {
          resolve(c.value === "ABC" ? { async: true } : null);
          return;
        }
        resolve(null);
      }, 3000);
    });
  }
}

@Component({
  selector: "common-validators",
  template: `
  <usecase-container title="Validators" src="common/validators">
    <usecase-content>
      <form>
        <span>Required: </span><input type="text" [ngFormControl]="required">
        <span class="error" *ngIf="!required.valid">Invalid!</span><br>
        
        <span>MinLength(3): </span><input type="text" [ngFormControl]="minLength">
        <span class="error" *ngIf="!minLength.valid">Invalid!</span><br>
        
        <span>MaxLength(5): </span><input type="text" [ngFormControl]="maxLength">
        <span class="error" *ngIf="!maxLength.valid">Invalid!</span><br>
        
        <span>Pattern("[a-z]+"): </span><input type="text" [ngFormControl]="pattern">
        <span class="error" *ngIf="!pattern.valid">Invalid!</span><br>
        
        <span>Composed(3-5): </span><input type="text" [ngFormControl]="composed">
        <span class="error" *ngIf="!composed.valid">Invalid!</span><br>
        
        <span>ColorCode(#xxxxxx): </span><input type="text" [ngFormControl]="colorCode">
        <span class="error" *ngIf="!colorCode.valid">Invalid!</span><br>
        
        <span>Async(not ABC): </span><input type="text" [ngFormControl]="async">
        <span class="error" *ngIf="!async.valid">Invalid!</span><br>
        
      </form>
    </usecase-content>
  </usecase-container>
    `,
  styles: [`.error { color: red}`]
})
export class ValidatorsComponent {

  private required = new Control("", Validators.required);
  private minLength = new Control("ab", Validators.minLength(3));
  private maxLength = new Control("abcdef", Validators.maxLength(5));
  private pattern = new Control("aBc", Validators.pattern("[a-z]+"));
  private composed = new Control("ab",
    Validators.compose([Validators.minLength(3), Validators.maxLength(5)]));
  private colorCode = new Control("#0000000", new ColorCodeValidator().validate);
  private async = new Control("ABC", null, AsyncValidator.validate);

}



/** WEBPACK FOOTER **
 ** ./script/common/validators/component.ts
 **/